import { withStyles } from '@material-ui/core/styles';
import { TableHead, Theme } from '@material-ui/core';

export const PasslyTableHead = withStyles((theme: Theme) => ({
    root: {
        height: 32,
        backgroundColor: theme.tablerow.secondary
    }
}))(TableHead);
